import styled from 'styled-components'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { colors, device } from 'Styled/variables'
import { Container as BaseContainer } from '../styles'

export const Container = styled(BaseContainer)`
  > span {
    margin-top: 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: left;
    margin-bottom: 16px;
  }
  color: ${colors.mainText};

  @media ${device.mobileMin} {
    font-size: 1.125rem;
    margin-top: 6px;
    margin-bottom: 15px;
    text-align: center;
  }
`

export const CancelTrack = styled.div`
  align-self: center;
  font-size: 0.875rem;
  border-bottom: 1px dashed currentColor;
  width: fit-content;
  cursor: pointer;
  margin-top: 38px;
  line-height: 21px;
`

export const StyledGreenBtn = styled(GreenBtn)`
  align-self: center;

  &:disabled {
    border-color: ${colors.greyTextBlackBg};
    color: ${colors.greyTextBlackBg};
  }
`
